import { getPwaStaticReloadSafety } from "@/lib/pwaRuntimeContract";

export const PWA_RELOAD_SAFETY_EVENT = "yb:pwa-reload-safety";

function blockerStore() {
  if (typeof window === "undefined") return {};
  if (!window.__ybPwaReloadBlockers) window.__ybPwaReloadBlockers = {};
  return window.__ybPwaReloadBlockers;
}

export function setPwaReloadBlocker(key, unsafe, reason = "Unsaved work is still being saved.") {
  if (typeof window === "undefined" || !key) return;
  const blockers = blockerStore();
  if (unsafe) blockers[key] = { reason, updatedAt: Date.now() };
  else delete blockers[key];
  window.dispatchEvent(new CustomEvent(PWA_RELOAD_SAFETY_EVENT));
}

export function clearPwaReloadBlocker(key) {
  setPwaReloadBlocker(key, false);
}

export function getPwaReloadSafety() {
  if (typeof window === "undefined") {
    return { safe: true, offline: false, reason: null };
  }
  const offline = typeof navigator !== "undefined" && navigator.onLine === false;
  const blockers = blockerStore();
  const firstBlocker = Object.values(blockers)[0] || null;
  const staticSafety = getPwaStaticReloadSafety(
    window.location.pathname,
    window.location.search,
    window.location.hash
  );
  const isPosRegisterRoute = staticSafety.category === "pos";
  const posReadinessUnknown =
    isPosRegisterRoute &&
    !Object.prototype.hasOwnProperty.call(blockers, "pos") &&
    window.__ybPosReloadReady !== true;
  const reason =
    firstBlocker?.reason ||
    (posReadinessUnknown ? "The register is still checking for an active sale." : null) ||
    (staticSafety.category === "pos" && window.__ybPosReloadReady === true
      ? null
      : staticSafety.reason);
  return {
    safe: !offline && !reason,
    offline,
    reason: offline ? "Reconnect before updating the app." : reason,
  };
}

export function markPosReloadReadiness(ready) {
  if (typeof window === "undefined") return;
  window.__ybPosReloadReady = ready === true;
  window.dispatchEvent(new CustomEvent(PWA_RELOAD_SAFETY_EVENT));
}
